import { Form } from 'factorial-form'

class TimeoffPolicySelectForm extends Form {
  constructor(values: {}) {
    super(values, {
      timeoff_policy_id: 'number',
      timeoff_allowance_id: 'number',
    })
  }
}

export default TimeoffPolicySelectForm
